import "scenes/thread/components/GuestDetails.scss";

import GuestImage from "components/GuestImage";
import UnhappyGuest from "scenes/thread/components/UnhappyGuest";

export const MultiplatGuestDetails = ({ booking, refreshThread }) => {
  if (!booking) return null;

  return (
    <div className="GuestDetails">
      <div className="GuestDetails__basic">
        <GuestImage
          url={booking.guest_photo_url}
          status={booking.approved ? "accepted" : "denied"}
          size="large"
        />
        <div>
          <div className="GuestDetails__guest">
            <h4>{booking.guest_name}</h4>
          </div>
          <div>
            <UnhappyGuest booking={booking} refreshThread={refreshThread} />
          </div>
        </div>
      </div>
    </div>
  );
};
